import { useEffect } from "react"
import { observer } from "mobx-react"
import parse from "react-html-parser"
import {
  Page,
  FooterNotFound,
  NotFoundAnimation,
  useStore,
} from "@features/common"
import { serverSidePagePrepare } from "@lib/hooks"

export const getServerSideProps = serverSidePagePrepare({})

const NotFoundPage = observer(function NotFoundPage() {
  const { GlobalModel, AnalyticsModel } = useStore()

  useEffect(() => {
    AnalyticsModel.globalNotFoundPageView()
  }, [AnalyticsModel])

  return (
    <Page
      meta={{
        title: GlobalModel.getTemplate("notFound"),
      }}
      footer={<FooterNotFound />}
      className="flex flex-col"
    >
      <div
        key={GlobalModel.lang}
        className="flex flex-1"
        data-test-id="not_found"
      >
        <div className="container pr-0 tablet:pr-0 desktop:pr-0">
          <div className="w-full h-full flex flex-col tablet-lg:flex-row">
            <div className="pr-4 flex flex-col flex-1 justify-center tablet:pr-10 tablet-lg:pt-5 tablet-lg:pr-0 tablet-lg:pb-5">
              <h1 className="mb-4 tablet:mb-6 font-sans text-5xl uppercase tracking-2 tablet:text-[64px] tablet:leading-tight tablet:tracking-[6px]">
                {parse(GlobalModel.getTemplate("404.title", true))}
              </h1>
              <p className="m-0 text-sm font-normal text-gray-250 mobile-m:text-xl tablet:text-3xl tablet:leading-9">
                {parse(GlobalModel.getTemplate("404.text", false))}
                <br />
                <a
                  href="https://pure.app/"
                  className="inline-block mt-2 pb-1.5 tablet:mt-4 tablet:pb-0 uppercase text-black border-b-2 border-dotted border-b-black"
                  data-test-id="not_found__link"
                >
                  {GlobalModel.getTemplate("404.link")}
                </a>
              </p>
              <p className="mt-6 mb-0 font-serif-italic text-lg text-gray-250 tablet:text-2xl desktop:mt-10">
                {GlobalModel.getTemplate("404.caption")}
              </p>
            </div>
            <div className="relative flex flex-col items-end mobile-m:mt-5 tablet-lg:mt-auto tablet-lg:flex-1">
              <NotFoundAnimation />
            </div>
          </div>
        </div>
      </div>
    </Page>
  )
})

export default NotFoundPage
